import React from 'react';
import styled from 'styled-components';
import { BlueBorderButton } from 'components/Button';
import Modal, { ModalHeader, ModalMessage } from 'components/Modal';

const ButtonRow = styled.div``;
const ConfirmationModal = ({ header, message, updateModalState }) => {
  return (
    <Modal style={{ padding: '2em 3em', paddingBottom: '2.5em' }}>
      {header ? <ModalHeader>{header}</ModalHeader> : null}
      {message ? <ModalMessage>{message}</ModalMessage> : null}
      <ButtonRow>
        <BlueBorderButton margin="0 16px 0 0" onClick={updateModalState}>
          Close
        </BlueBorderButton>
      </ButtonRow>
    </Modal>
  );
};

export default ConfirmationModal;
